import React, { useState } from "react";
import { StyleSheet, Text, TextInput } from "react-native";
export function EditText({
  placeholder,
  keyboardType,
  style,
  onChangeText,
  value,
  onBlur,
  multiline = false,
  maxLength,
}) {
  const [newStyle, setNewStyle] = useState(styles.textInput);

  return (
    <TextInput
      style={[newStyle, style]}
      placeholder={placeholder}
      placeholderTextColor="grey"
      keyboardType={keyboardType}
      autoFocus={false}
      maxLength={maxLength}
      onBlur={() => {
        onBlur;
        setNewStyle(styles.textInput);
      }}
      onFocus={(e) => {
        setNewStyle(styles.textInputFocus);
      }}
      onChangeText={(text) => onChangeText(text)}
      multiline={multiline}
      value={value}
    />
  );
}

const styles = StyleSheet.create({
  label: {
    marginTop: 16,
    textAlign: "left",
    marginStart: 20,
    marginBottom: 4,
    fontSize: 16,
    alignSelf: "flex-start",
  },
  textInput: {
    minWidth: 300,
    borderColor: "#A0A0A0",
    paddingHorizontal: 16,
    borderWidth: 2,
    height: 55,
    fontSize: 16,
    color: "#000000",
    fontWeight: "600",
    borderRadius: 4,
    outlineStyle: "none",
  },
  textInputFocus: {
    minWidth: 300,
    borderWidth: 2,
    height: 55,
    fontSize: 16,
    color: "#000000",
    fontWeight: "600",
    borderColor: "#01786E",
    paddingHorizontal: 16,
    borderRadius: 4,
    outlineStyle: "none",
  },
});
